<template>
  <v-dialog v-model="dialog" max-width="600" @keydown.esc="cancel()" persistent :fullscreen="$vuetify.breakpoint.xsOnly">
    <v-card>
      <v-toolbar dark color="primary">
        <v-toolbar-title class="white--text">{{
          newMethod ? $t('work_methods.create_new_method') : $t('work_methods.edit_method')
        }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="cancel">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="pt-5">
        <v-form ref="form">
          <v-text-field
            :disabled="saving"
            outlined
            dense
            :label="$t('work_methods.name')"
            :rules="[$rules.required]"
            v-model="method.name"
            validate-on-blur
          />
          <v-text-field
            :disabled="saving"
            outlined
            dense
            type="number"
            :label="$t('work_methods.sort_order')"
            v-model.number="method.sortOrder"
          />
          <v-switch :disabled="saving" inset :label="$t('work_methods.active')" v-model="method.active" />
          <v-switch
            :disabled="saving"
            inset
            :label="$t('work_methods.accrues_drilled_meters')"
            :hint="$t('work_methods.accrues_drilled_meters_hint')"
            persistent-hint
            v-model="method.accruesDrilledMeters"
          />
          <v-select
            v-if="!newMethod"
            :disabled="saving"
            outlined
            dense
            class="mt-4"
            :items="pricingOptions"
            :label="$t('work_methods.pricing_def')"
            :hint="$t('work_methods.pricing_def_hint')"
            persistent-hint
            v-model="method.pricingDefId"
          />
        </v-form>
        <v-alert :value="showAlert" outlined type="error">{{ $t('validation.check_all_required_fields') }}</v-alert>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="default" @click.native="cancel()">{{ $t('cancel') }}</v-btn>
        <v-btn color="primary" :loading="saving" @click.native="save()">{{ $t('save') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import workMethodsApi from '@/api/workMethods';

const methodTemplate = {
  id: null,
  name: '',
  active: true,
  sortOrder: null,
  accruesDrilledMeters: false,
  pricingDefId: null,
};

export default {
  name: 'WorkMethodDialog',
  data() {
    return {
      dialog: false,
      saving: false,
      showAlert: false,
      newMethod: true,
      method: { ...methodTemplate },
      /** Hinnoitteluperusteeksi kelpaavat menetelmän parametrit (työkohtainen numero). */
      numberDefs: [],
    };
  },
  computed: {
    pricingOptions() {
      return [
        { text: this.$t('work_methods.pricing_lot'), value: null },
        ...this.numberDefs.map(d => ({ text: d.unit ? `${d.label} (${d.unit})` : d.label, value: d.id })),
      ];
    },
  },
  methods: {
    open(existingMethod) {
      this.dialog = true;
      this.showAlert = false;
      this.newMethod = existingMethod == null;
      this.$refs.form?.resetValidation();
      this.numberDefs = (existingMethod?.attributes || []).filter(a => a.scope === 'WORK' && a.valueType === 'NUMBER');
      if (existingMethod == null) {
        this.method = { ...methodTemplate };
      } else {
        this.method = {
          id: existingMethod.id,
          name: existingMethod.name,
          active: existingMethod.active !== false,
          sortOrder: existingMethod.sortOrder,
          accruesDrilledMeters: existingMethod.accruesDrilledMeters === true,
          pricingDefId: existingMethod.pricingDefId || null,
        };
      }
    },
    cancel() {
      this.dialog = false;
      this.method = { ...methodTemplate };
      this.showAlert = false;
    },
    async save() {
      if (!this.method.name) {
        this.showAlert = true;
        return;
      }
      const payload = {
        name: this.method.name,
        active: this.method.active,
        sortOrder: this.method.sortOrder === '' ? null : this.method.sortOrder,
        accruesDrilledMeters: this.method.accruesDrilledMeters,
        pricingDefId: this.method.pricingDefId,
      };
      try {
        this.saving = true;
        if (this.newMethod) {
          await workMethodsApi.createWorkMethod(payload);
          this.$emit('created');
        } else {
          await workMethodsApi.updateWorkMethod(this.method.id, payload);
          this.$emit('updated');
        }
        this.cancel();
      } catch (err) {
        this.$handleApiError(err);
      }
      this.saving = false;
    },
  },
};
</script>
